<template>
	<div>
		<span v-if="isOk" class="icon-label icon-label-success"><v-icon>far fa-check</v-icon> <b style="margin-right: 4px;">{{age}}</b> min</span>
		<span v-else class="icon-label icon-label-error"><v-icon>far fa-exclamation</v-icon> <b style="margin-right: 4px;">{{age}}</b> min</span>
	</div>
</template>

<script>
import { DateTime, Interval } from "luxon";

export default {
	props: {
		heartbeat: String,
		limit: Number,
		time: Object,
	},
	data() {
		return {};
	},
	computed: {
		age() {
			const minutes = Math.round(Interval.fromDateTimes(DateTime.fromISO(this.heartbeat, { zone: "utc" }), this.time).length("minutes") * 10) / 10;
			return Number.isNaN(minutes) ? 0 : minutes;
		},
		isOk() {
			return this.age < this.limit;
		},
	},
};
</script>
